import request from '@/service/request'

/* 学生用水记录 page接口 */
export const pageStuWaterFeeRecordApi = (params) => {
  return request.post('/stu/water/pageDetailUseRecord', params)
}

/* 学生用水记录 新水表 page接口 */
export const pageNewWaterUsageRecordApi = (params) => {
  return request.post('/handle/newWaterUseSet/pageUseRecords', params)
}
